import { callable } from '../callable';

export interface PaymentIntegrationStateDto {
  connected: boolean;
  status: string;
  mpUserId: string | null;
  nickname: string | null;
  email: string | null;
  connectedAt: string | null;
  lastError: string | null;
}

export const mercadopagoApi = {
  getState: async (data: { tenantId: string }): Promise<PaymentIntegrationStateDto> => {
    const fn = callable<typeof data, PaymentIntegrationStateDto>('getMercadoPagoIntegrationState');
    return (await fn(data)).data;
  },
  getConnectUrl: async (data: {
    tenantId: string;
    returnOrigin?: string;
  }): Promise<{ url: string }> => {
    const fn = callable<typeof data, { url: string }>('getMercadoPagoConnectUrl');
    return (await fn(data)).data;
  },
  disconnect: async (data: { tenantId: string }): Promise<{ success: boolean }> => {
    const fn = callable<typeof data, { success: boolean }>('disconnectMercadoPago');
    return (await fn(data)).data;
  },
};
